module.exports = __webpack_public_path__ + "resources/68ac190d443e3a23a134750b0bc96c3a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/backgroundshlevel.png
// module id = 194
// module chunks = 0